import { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { MobileNavigation } from '@/app/layouts/app-layout/MobileNavigation';
import { env } from '@/shared/config';
import { PageLoader } from '@/shared/ui';
import { DesktopSidebar } from '@/components/base/desktop/desktopHeader/DesktopSidebar';
import { useAuthStore } from '@/store/auth';

/**
 * Лэйаут разделов, которые несут свой верхний бар: «Финансы», «ЭДО» и
 * «Операционный пульс».
 *
 * `container` из AppLayout здесь не годится — он режет ширину до 1280px, а модули
 * свёрстаны во всю ширину (лента навигации и закреплённые полосы тянутся от края
 * до края). Глобальный Header тоже не рендерим: у модулей своя шапка с
 * переключением экранов, поиском и действиями.
 *
 * Suspense вокруг `Outlet` — обязателен: без него ленивый чанк страницы подвешивал
 * корневой Suspense в App.tsx, и на время загрузки пропадал весь экран, включая
 * сайдбар. Со своей границей грузится только область контента (как в AppLayout).
 */
export function FullWidthLayoutRoute() {
  const isAuthenticated = useAuthStore(
    (state) => env.authBypass || state.isAuthenticated
  );
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="flex min-h-screen bg-background">
      <DesktopSidebar />
      <div className="h-screen min-w-0 flex-1 overflow-y-auto overflow-x-hidden">
        <Suspense fallback={<PageLoader className="h-full" />}>
          <Outlet />
        </Suspense>
      </div>
      <MobileNavigation />
    </div>
  );
}
